/**
 * Layout route for the settings section (/_app/settings).
 *
 * This file is intentionally minimal — its sole job is to provide an
 * <Outlet /> so that child routes (settings/index, settings/branches,
 * settings/master-data, etc.) can render their own content.
 *
 * The Settings home page lives in settings/index.tsx.
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  return <Outlet />;
}
